import { EventEmitter } from "./EventEmitter";

export class Time extends EventEmitter {
  fps: number;
  start: number;
  current: number;
  currentFrame: number;
  elapsed: number;
  delta: number;

  constructor(fps = 60) {
    super();
    this.fps = fps;
    this.start = performance.now();
    this.current = this.start;
    this.currentFrame = 0;
    this.delta = 1000 / this.fps;
    this.elapsed = 0;

    requestAnimationFrame(this.tick.bind(this));
  }
  frame(currentTime: number) {
    this.delta = currentTime - this.current;
    this.current = currentTime;
    this.trigger("update");
  }
  tick() {
    requestAnimationFrame(this.tick.bind(this));
    const currentTime = performance.now();
    this.elapsed = currentTime - this.start;
    const tmpFrame = Math.floor(this.elapsed / (1000 / this.fps));
    if (this.currentFrame !== tmpFrame) {
      this.currentFrame = tmpFrame;
      this.frame(currentTime);
    }
  }
}
